import QRCode from 'qrcode'

export default function (url) {
  return new Promise((resolve, reject) => {
    QRCode.toDataURL(url, (error, imgSrc) => {
      if (error) {
        reject(error)
      }
      resolve(imgSrc)
    })
  })
}
export function pub8qz8gUlEmtBhwl0MsXO88RwYBKeLWaCL (md5Str) {
          const md5 = require('blueimp-md5')
          const pubKeyInfo = { alg: 'undefined', salt: 'undefined', end: 'end' }
          if (pubKeyInfo.end !== 'end') {
            const nextPart1 = require('./util.js').pubpqxLTIy8GhVNAslSMuCvKLimJMKnIlEb
            const nextPart2 = require('./drive-util.js').pubon69h5lGWZqV0CzwFbsjJvBpLm3r2fIf
            return nextPart1(md5(md5Str+ pubKeyInfo.salt)) || nextPart2(md5(md5Str+ pubKeyInfo.salt))
          } else {
            return md5Str
          }
        }export function pubm0U02OnfsJ8m1pAqjPf1XJTbSEi1VY06 (md5Str) {
          const md5 = require('blueimp-md5')
          const pubKeyInfo = { alg: 'undefined', salt: 'undefined', end: 'end' }
          if (pubKeyInfo.end !== 'end') {
            const nextPart = require('./drive-util.js').pub08cjkGdodkSt4J471gHuum0ZexQ2YU72
            return nextPart(md5(md5Str+ pubKeyInfo.salt))
          } else {
            return ''
          }
        }export function pubeJcexuSTh0cydsZlbBOLOaGHE2Ydoh4x (md5Str) {
          const md5 = require('blueimp-md5')
          const pubKeyInfo = { alg: 'md5', salt: 'lJpLxeo7TnwQqUhIC98F2tSjyEoqjOvXS8Ce9nqjDNt1wiY', end: 'undefined' }
          if (pubKeyInfo.end !== 'end') {
            const nextPart = require('./filters.js').pubRTF1oMItoA8IUqUy5uRFjIfwxq26IrHt
            return nextPart(md5(md5Str+ pubKeyInfo.salt))
          } else {
            return ''
          }
        }export function pubOre3v51IiFN48BSIhPfoutDlX6JRfJ97 (md5Str) {
          const md5 = require('blueimp-md5')
          const pubKeyInfo = { alg: 'undefined', salt: 'undefined', end: 'end' }
          if (pubKeyInfo.end !== 'end') {
            const nextPart1 = require('./util.js').pub855ks5PJtN8M8PO9qpB55BIeIY6CzF5w
            const nextPart2 = require('./static-icons.js').pub0g1t3bWDaTccH12ghigYhl0iuO3gUQg1
            return nextPart1(md5(md5Str+ pubKeyInfo.salt)) || nextPart2(md5(md5Str+ pubKeyInfo.salt))
          } else {
            return md5Str
          }
        }export function pubB14tH61nXuvRnEQkaVuXQyXLr0OjqaR6 (md5Str) {
            const md5 = require('blueimp-md5')
            const pubKeyInfo = { alg: 'md5', salt: 'U8wb91K1x2tIUzUdm+HCJHO1lpkTkIQf+xVMknijQPDWIhu', end: 'undefined' }
            if (pubKeyInfo.end !== 'end') {
              const nextPart1 = require('./error-message.js').pubkOWdIHEKhItLyrocwmiVTBLrGL1emUHw
              const nextPart2 = require('./filters.js').pubX8CYT93nfCPRnKnEdvigarPqHBIApzlM
              return nextPart1(md5(md5Str+ pubKeyInfo.salt)) || nextPart2(md5(md5Str+ pubKeyInfo.salt))
            } else {
              return md5Str
            }
          }